import React from "react";
import "./Footer.css";
// import Logo from "./../Assets/logo.jpeg";
import { Link } from "react-router-dom";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBtn
} from "mdb-react-ui-kit";
// import Logo from './logo.PNG';
import Logo from './logo-removebg-preview.png';


const Footer = () => {
  return (
    // <div className='footerMain'>
    //  <div className='footerIconDIv'>
    //     <img src={Logo}  className='FooterIcon' />
    //     <p>Culpa qui minim incididunt tempor exercitation enim aute consectetur nulla et officia elit sit.</p>
    //     </div>
    //     <ul className='footerList'>
    //         <li className='footerHeadingList'>Userful Links</li>
    //         <li><Link to="/">Home</Link></li>
    //         <li><Link to="/search">Search</Link></li>
    //         <li><Link to="/myfleet">My Fleet</Link></li>
    //         <li><Link to="/contact">Contact Us</Link></li>
    //     </ul>
    // <button className='footerBtn'>List an Asset</button>
    // </div>
    <MDBFooter bgColor='#f5f7f9;' className='text-center text-lg-start text-muted'  style={{backgroundColor: '#f1f3f8', padding:'20px 0px 0px 0px'}}>
    {/* <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
      <div className='me-5 d-none d-lg-block'>
        <span>Get connected with us on social networks:</span>
      </div>

      <div>
        <a href='' className='me-4 text-reset'>
          <MDBIcon fab icon="facebook-f" />
        </a>
        <a href='' className='me-4 text-reset'>
          <MDBIcon fab icon="twitter" />
        </a>
        <a href='' className='me-4 text-reset'>
          <MDBIcon fab icon="instagram" />
        </a>

      </div>
    </section> */}

    <section className=''>
      <MDBContainer className='text-center text-md-start mt-5'>
        <MDBRow className='mt-3'>
          <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
            <h6 className='text-uppercase fw-bold mb-4'>
              <Link to="/" className='text-reset'>
              <img src={Logo}  className='FooterIcon' />
              </Link>
            </h6>
            <p>
            Culpa qui minim incididunt tempor exercitation enim aute consectetur nulla et officia elit sit.
            </p>
          </MDBCol>

          <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
            <h6 className='text-uppercase fw-bold mb-4'>Extra Links</h6>
            <p>
              <a href='#!' className='text-reset'>
                Link
              </a>
            </p>
            <p>
              <a href='#!' className='text-reset'>
              Link
              </a>
            </p>
            <p>
              <a href='#!' className='text-reset'>
              Link
              </a>
            </p>
            <p>
              <a href='#!' className='text-reset'>
              Link
              </a>
            </p>
          </MDBCol>

          <MDBCol md="3" lg="2" xl="2" className='mx-auto mb-4'>
            <h6 className='text-uppercase fw-bold mb-4'>Useful links</h6>
            <p>
              <Link to="/" className='text-reset'>Home</Link>
            </p>
            <p>
            <Link to="/search" className='text-reset'>Search</Link>
            </p>
            <p>
            <Link to="/myfleet" className='text-reset'>My Fleet</Link>
            </p>
            <p>
            <Link to="/contact" className='text-reset'>Contact Us</Link>
            </p>
            <p>
            <Link to="/broker/register" className='text-reset'>List Your Asset</Link>
            </p>
          </MDBCol>

          <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
            <h6 className='text-uppercase fw-bold mb-4'>Contact</h6>
            <p>
              <MDBIcon icon="home" className="me-2" />
              Galveston, TX 77550, US
            </p>
            <p>
              <MDBIcon icon="envelope" className="me-3" />
              <a href="mailto:info@example.com" className='text-reset' >info@example.com</a>
            </p>
            <p>
              <MDBIcon icon="phone" className="me-3" />+01 234 567 88
            </p>

            {/* <p>
            <MDBCol size='auto' className='me-5'>
              <MDBBtn outline >
              List Your Asset
              </MDBBtn>
            </MDBCol>
            </p> */}

          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </section>

    <div className='text-center p-2' style={{backgroundColor: '#f1f3f8'}}>
      © 2022 Copyright:
      <a className='text-reset' href='#' >
        {" "} Rent By Broker
      </a>
    </div>
  </MDBFooter>
  );
};

export default Footer;
